import {
  GroupBase,
  SingleValueProps,
} from "react-select"

const SingleValue = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({ children }: SingleValueProps<Option, IsMulti, Group>) => {
  return (
    <div className="truncate">
      {children}
    </div>
  )
}

export default SingleValue
